import { useEffect, useState } from "react";
import "./CourseCardAll.css";

import person1WhatYouWillDo2 from "../img/person1WhatYouWillDo2.svg";
  import { useRouteMatch,Switch, Route ,Link} from "react-router-dom";
import { AlarmSmoke, BellElectric, BotMessageSquare, ChevronDown, ChevronRight, ChevronsLeftRightEllipsis, CornerDownRight, Heart, LayoutDashboard, LayoutGrid, LayoutPanelLeft, ListChecks, ListFilter, ListMusic, Minus, Pencil, Play, Plus, ShoppingCart, Trash2, X } from "lucide-react";

const CourseCardAllInfoPage= ({item ,appItem,arrCourseCards})=>{
const [hoverCourseCard, setHoverCourseCard] = useState(false);
const [popUpItem, setPopUpItem] = useState({});
        const [showFAQIndex, setShowFAQIndex] = useState(0);
   
return(<>

                    {item?.whatWillILearn?
                     <div className="theme1"  style={{margin:"10px",marginTop:"20px",overflow:"hidden",
                       minHeight:"190px",borderRadius:"25px",background:"#f9f9f9",position:"relative"}}>
                     <div style={{position:"absolute",right:"0px",top:"0px",borderTopLeftRadius:"5px",
                       borderBottomLeftRadius:"50px",background:"#EBF6FF"}}>
                     <img    className="" src={person1WhatYouWillDo2} 
                             alt="selected Img"
                        style={{cursor:"pointer",width:"100px"
                         
                        }}/>
                     </div>
                     <div className="theme1 courseContentTitleFont">What you'll learn</div>
                     <div className="theme1 ">
                       {item?.whatWillILearn?JSON.parse(item?.whatWillILearn).map((itemWhLearn,indexWhLearn)=>(
                  <><div   style={{display:"flex",justifyContent:"left",flexWrap:"nowrap",marginBottom:"10px" }}>
                           <ListChecks strokeWidth={3} absoluteStrokeWidth  size={23}  color="#90CAF9"/> 
                           <div className="theme1 "
                      style={{fontSize:"14px",color:"#111",fontWeight:"500"}}> 
                        {itemWhLearn?.paragraph}
                           </div>
                           </div></>
                       )):""
                    }
                          
                     </div>
                     
                     
                     
                       
                       </div>:""}
                     
                       
                         {item?.skills? <div className="theme1 "  style={{marginTop:"20px",overflow:"hidden",
                         minHeight:"190px",position:"relative"}}><div style={{}}>
                         <div style={{background:"rgba(255,114,94,0.051)",borderRadius:"15px",padding:"10px",margin:"5px"}} >
                         <div className="theme1 "  style={{
                         borderRadius:"25px",margin:"3px",display:"flex",justifyContent:"left"}}>
                         <div style={{background:"rgba(255,114,94,0.9)",width:"56px",height:"56px",borderRadius:"50%",padding:"0px"}} >
                         <AlarmSmoke strokeWidth={4} absoluteStrokeWidth  size={40} style={{margin:"8px",marginTop:"10px"}} color="#fff" />  </div>
                         <div className="theme1"   style={{margin:"4px",fontSize:"26px",color:"rgba(255,114,94,0.9)",fontWeight:"800"}}>
                             Skills </div>
                             </div>
                       <div><div   >
                           
                        
                        
                         </div>
                         <div className="gridForWhatsNextAfterYT5">
                     {item?.skills?JSON.parse(item?.skills)?.map((itemSkills,indexSkills)=>(
                      <><div    style={{display:"flex",justifyContent:"left",flexWrap:"nowrap",marginBottom:"10px" }}>
                             <ListMusic   strokeWidth={2} absoluteStrokeWidth  size={23}  color="rgba(123, 92, 167, 0.9)"/> 
                        
                       <div className="theme1 "
                        style={{fontSize:"14px",color:"#111",fontWeight:"500"}}> 
                            
                          {itemSkills?.paragraph}
                        
                             </div> </div></>
                     )):""}</div>
                           </div>
                         </div></div> </div>:""}
                         
                      {item?.highlights?
                       <div className="theme1"  style={{marginTop:"10px",overflow:"hidden",
                         minHeight:"190px",borderRadius:"25px",background:"#fff",position:"relative"}}>
                        <div className="theme1 whatIncludesInSidebar courseContentTitleFont "  style={{
                         borderRadius:"25px",margin:"3px"}}>
                         
                         <BellElectric  strokeWidth={4} absoluteStrokeWidth  size={47} style={{marginTop:"-10px"}} color="#9690da" />
                         
                         Highlights
                         </div>
                         
                       
                       <div className="theme1 " style={{
                         margin:"5px",marginTop:"5px"}}>
                         {item?.highlights?JSON.parse(item?.highlights)?.map((itemHighlights,indexHighlights)=>(
                             <div    style={{display:"flex",justifyContent:"left",flexWrap:"nowrap",marginBottom:"10px" }}>
                             <LayoutGrid   strokeWidth={2} absoluteStrokeWidth  size={23}  color="rgba(255,114,94,0.9)"/> 
                             <div className="theme1 "
                        style={{fontSize:"14px",color:"#111",fontWeight:"500"}}> 
                          {itemHighlights?.paragraph}
                             </div>
                             </div>)):""}
                       </div>
                       
                       
                       
                         
                         </div>:""}
                     
                    {item?.preRequisite||item?.targetAudience?
                          <div className="theme1"  style={{margin:"10px",marginTop:"20px",overflow:"hidden",
                       minHeight:"190px",borderRadius:"25px",background:"rgba(144, 202, 249,0.1)",position:"relative"}}>
                     <div style={{position:"absolute",right:"0px",top:"0px",borderTopLeftRadius:"5px",
                       borderBottomLeftRadius:"50px",}}>
                     
                     </div>
                     
                     <div className=" gridForWhatsNextAfterYT5"  style={{marginTop:"20px",overflow:"hidden",
                         minHeight:"190px",position:"relative"}}>
                      {item?.targetAudience?
                     <div className=" ">
                     <div className="theme1 courseContentTitleFont">Target Audience</div>
                          {item?.targetAudience?JSON.parse(item?.targetAudience)?.map((itemTargetAudience,indexTargetAudience)=>(
                              <div    style={{display:"flex",justifyContent:"left",flexWrap:"nowrap",marginBottom:"10px" }}>
                           <ListFilter strokeWidth={3} absoluteStrokeWidth  size={23}  color="#90CAF9"/> 
                           <div className="theme1 "
                      style={{fontSize:"14px",color:"#111",fontWeight:"500"}}> 
                       {itemTargetAudience?.paragraph}
                           </div>
                           </div>)):""}
                     </div>:""}
                      {item?.preRequisite?
                     <div className="" style={{borderRadius:"25px",background:"#fff",position:"relative"}} >
                        
                     <div className="theme1 courseContentTitleFont" >Prerequisite</div>
                      
                         
                       
                       <div className=" " style={{
                         padding:"10px",marginTop:"5px"}}>
                          {item?.preRequisite?JSON.parse(item?.preRequisite)?.map((itemPreRequisite,indexPreRequisite)=>(
                         
                         <div    style={{display:"flex",justifyContent:"left",flexWrap:"nowrap",marginBottom:"10px" }}>
                             <LayoutPanelLeft   strokeWidth={2} absoluteStrokeWidth  size={23}  color="#222"/> 
                             <div className="theme1 "
                        style={{fontSize:"14px",color:"#222",fontWeight:"500"}}> 
                          {itemPreRequisite?.paragraph}
                             </div>
                             </div>)):""}
                       </div>
                       
                       
                       
                         
                         </div>:""}
                     
                       
                         </div> 
                         </div> :""}
                         {item?.FAQs?
                     <div className="theme1"  style={{marginTop:"20px",overflow:"hidden",
                       minHeight:"190px",borderRadius:"25px",background:"#fff",position:"relative"}}>
                     <div className="theme1 whatIncludesInSidebar FAOuterTitle  "  style={{
                       borderRadius:"25px",marginTop:"10px",fontWeight:"900",color:"#222"}}>
                       
                       <BotMessageSquare   strokeWidth={4} absoluteStrokeWidth  size={47} style={{marginTop:"-10px"}} color="#9690da" />
                       
                       FAQs
                       </div>
                     
                     <div className=" ">
                        {item?.FAQs?JSON.parse(item?.FAQs)?.map((itemFAQs,indexFAQs)=><>
                        <div className="outerFAQShadow">
                    
                         {itemFAQs?.FAQ?
                          <>
                           <div  className="courseFAQActive" >
                             <div className="theme1 FAQQuestionStyle"
                      > 
                      FAQ {indexFAQs+1}:  {itemFAQs?.FAQ?.question}
                      
                           </div> 
                           <div onClick={()=>{setShowFAQIndex(indexFAQs)}}
                            style={{background:"#fff",width:"40px",height:"40px",borderRadius:"50%"}}>
                              {showFAQIndex==indexFAQs?<Minus strokeWidth={3} absoluteStrokeWidth  size={29} style={{margin:"5px"}}  color="rgba(255,114,94,0.7)"/>:
                              <Plus strokeWidth={3} absoluteStrokeWidth  size={29} style={{margin:"5px"}}  color="rgba(255,114,94,0.7)"/>} </div>
                           </div>

                            {showFAQIndex==indexFAQs?itemFAQs?.FAQ?.answers?itemFAQs?.FAQ?.answers?.map((itemAnswer,indexAnswer)=>(<>
                             <div  className="courseFAQItemInner">
                           <CornerDownRight   strokeWidth={2} absoluteStrokeWidth  size={23}  color="rgba(255,114,94,0.7)"/> 
                           <div className="theme1 "
                      style={{fontSize:"13px",color:"#555",fontWeight:"500"}}> 
                        This Course Includes Hands On Exercises Videos And Tests 
                      
                           </div>
                           </div>
                            
                            </>)):"":""}
                          
                          
                          </>:""}
                        </div>
                          </>
                         ):"" }
                    
                     
                     
                     
                     </div>
                     
                       </div>:""} 

                       </>) }
      export default CourseCardAllInfoPage;